// extracted by mini-css-extract-plugin
export default {"wrapper":"V7-z"};